<script>
    export default {
        name: 'normal-picker-group',
        props: {
            items: {type: Array, default: () => []},
            height: {type: Number, default: 238},
            itemHeight: {type: Number, default: 25 + 9},
            indicatorTop: {type: Number, default: 102},
            indicatorHeight: {type: Number, default: 34},
            groupIndex: {type: Number, default: -1},
            defaultIndex: {type: Number, default: -1},
        },
        data () {
            return {
                touching: false,
                ogY: 0,
                ogTranslate: 0,
                touchId: undefined,
                translate: 0,
                totalHeight: 0,
                selected: 0,
                animating: this.animation
            };
        },
        watch: {
            defaultIndex () {
                this.adjustPosition();
            }
        },
        methods: {
            adjustPosition () {
                const {items, itemHeight, indicatorTop, defaultIndex} = this;
                const totalHeight = items.length * itemHeight;
                let translate = totalHeight <= indicatorTop ? indicatorTop : 0;
                if (defaultIndex > -1) {
                    if (translate === 0) {
                        let upperCount = Math.floor(indicatorTop / itemHeight);
                        if (defaultIndex > upperCount) {
                            let overCount = defaultIndex - upperCount;
                            translate -= overCount * itemHeight;
                        } else if (defaultIndex === upperCount) {
                            translate = 0;
                        } else {
                            translate += Math.abs(upperCount - defaultIndex) * itemHeight;
                        }
                    } else {
                        translate -= itemHeight * defaultIndex;
                    }
                }
                this.selected = defaultIndex;
                this.ogTranslate = translate;
                this.totalHeight = totalHeight;
                this.translate = translate;
                this.$nextTick(() => (defaultIndex > -1 ? this.updateSelected(false) : this.updateSelected()));
            },
            updateSelected (propagate = true) {
                const {items, itemHeight, indicatorTop, indicatorHeight, groupIndex} = this;
                let selected = -1;
                items.forEach((item, i) => {
                    if (!item.disabled &&
                        (this.translate + itemHeight * i) >= indicatorTop &&
                        (this.translate + itemHeight * i + itemHeight) <= (indicatorTop + indicatorHeight)) {
                        selected = i;
                    }
                });

                propagate && this.$emit('change', items[selected], selected, groupIndex);
            },
            handleTouchStart (e) {
                if (this.touching || this.items.length <= 1) return;
                this.touching = true;
                this.ogTranslate = this.translate;
                this.touchId = e.targetTouches[0].identifier;
                this.ogY = this.translate === 0 ? e.targetTouches[0].pageY : e.targetTouches[0].pageY - this.translate;
                this.animating = false;
            },
            handleTouchMove (e) {
                if (!this.touching || this.items.length <= 1) return;
                if (e.targetTouches[0].identifier !== this.touchId) return;
                e.preventDefault();
                const pageY = e.targetTouches[0].pageY;
                const diffY = pageY - this.ogY;
                this.translate = diffY;
            },
            handleTouchEnd (e) {
                if (!this.touching || this.items.length <= 1) return;
                const {indicatorTop, indicatorHeight, itemHeight} = this;
                let translate = this.translate;
                if (Math.abs(translate - this.ogTranslate) < itemHeight * 0.51) {
                    translate = this.ogTranslate;
                } else if (translate > indicatorTop) {
                    translate = indicatorTop;
                } else if (translate + this.totalHeight < indicatorTop + indicatorHeight) {
                    translate = indicatorTop + indicatorHeight - this.totalHeight;
                } else {
                    let step = 0,
                        adjust = 0;
                    let diff = (translate - this.ogTranslate) / itemHeight;
                    if (Math.abs(diff) < 1) {
                        step = diff > 0 ? 1 : -1;
                    } else {
                        adjust = Math.abs((diff % 1) * 100) > 50 ? 1 : 0;
                        step = diff > 0 ? Math.floor(diff) + adjust : Math.ceil(diff) - adjust;
                    }
                    translate = this.ogTranslate + step * itemHeight;
                }
                this.touching = false;
                this.ogY = 0;
                this.touchId = undefined;
                this.ogTranslate = 0;
                this.animating = true;
                this.translate = translate;
                this.$nextTick(() => this.updateSelected());
            }
        },
        mounted () {
            this.adjustPosition();
        },
        render () {
            const {
                items,
                className,
            } = this;
            const cls = this.$util.classNames('normal-picker__group', className);
            const styles = {
                transform: `translate(0, ${this.translate}px)`,
                transition: this.animating ? 'transform .3s' : 'none'
            };
            return (
                <div class={cls}
                     onTouchstart={this.handleTouchStart}
                     onTouchmove={this.handleTouchMove}
                     onTouchend={this.handleTouchEnd}>
                    <div class="normal-picker__mask"></div>
                    <div class="normal-picker__indicator"></div>
                    <div class="normal-picker__content" style={styles} ref="content">
                        {items.map((item, j) => {
                            const itemCls = this.$util.classNames('normal-picker__item', {
                                'normal-picker__item_disabled': item.disabled
                            });
                            return (
                                <div key={j} class={itemCls}>
                                    {item.text}
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }
    };
</script>


<style lang="less" scoped>
    @import "../../assets/less/widgets-var";

    .normal-picker {
        &__group {
            flex: 1;
            position: relative;
            height: 100%;
        }

        &__indicator {
            width: 100%;
            height: 34px;
            position: absolute;
            left: 0;
            top: 102px;
            z-index: 3;

            &:before {
                content: " ";
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                height: 1px;
                border-top: 1px solid @otherBorderClr;
                color: @otherBorderClr;
                transform-origin: 0 0;
                transform: scaleY(0.5);
            }

            &:after {
                content: " ";
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                height: 1px;
                border-bottom: 1px solid @otherBorderClr;
                color: @otherBorderClr;
                transform-origin: 0 100%;
                transform: scaleY(0.5);
            }
        }

        &__item_disabled {
            color: @otherBtnBorderNoteClr;
        }

        &__content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        &__mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin: 0 auto;
            z-index: 3;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6)), linear-gradient(0deg, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0.6));
            background-position: top, bottom;
            background-size: 100% 102px;
            background-repeat: no-repeat;
            transform: translateZ(0);
        }

    }

</style>
